import styled from 'styled-components';

export const H3 = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  color: #101938;
  margin-bottom: 16px;
  width: 100%;
`;

export const H6 = styled.h6`
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  color: #101938;
  margin-bottom: 16px;
  width: 100%;
`;
